import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import config from '../../app/config';
import { color } from '../../app/theme';
import { NodeType } from '../../app/types';
import { getMaxFlowCount } from '../../features/mainSlice';

const useStyles = makeStyles(
  {
    root: {
      position: 'absolute',
      top: 24,
      left: 24,
    },
    row: {
      marginBottom: 24,
      '& > div:first-child': {
        marginBottom: 6,
      },
      '& > div': {
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '1.38',
        letterSpacing: 'normal',
        color: color.$12,
      },
    },
    red: {
      color: `${color.$17} !important`,
    },
  },
  {
    name: 'Group',
  },
);

const UsageNum = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const dispatch = useDispatch();
  const { data } = useSelector(store => store.ma);
  const { nodes } = data || {};

  const [flowCount, setFlowCount] = useState(0);

  const maxFlowCount = config.MAX_FLOW_COUNT;
  const maxEndCount = config.MAX_END_COUNT;

  const endCount = useMemo(() => {
    return (nodes || []).filter(n => n?.type === NodeType.END).length || 0;
  }, [nodes.length]);

  const flowRemaining = maxFlowCount - flowCount;
  const endRemaining = maxEndCount - endCount;

  useEffect(() => {
    const count = dispatch(getMaxFlowCount());
    setFlowCount(count);
  }, [nodes.length]);

  return (
    <div className={classes.root}>
      <div className={classes.row}>
        <div>{t('usage.maxFlow', { num: maxFlowCount })}</div>
        <div
          className={classnames({
            [classes.red]: flowRemaining <= 0,
          })}
        >
          {t('usage.other', { num: flowRemaining })}
        </div>
      </div>
      <div className={classes.row}>
        <div>{t('usage.maxEnd', { num: maxEndCount })}</div>
        <div
          className={classnames({
            [classes.red]: endRemaining <= 0,
          })}
        >
          {t('usage.other', { num: endRemaining >= 0 ? endRemaining : 0 })}
        </div>
      </div>
    </div>
  );
};

export default UsageNum;
